export const popoverContent = () => (
    <div>
        Date à laquelle les pièces des dossiers ont été <span className="span-bold">lettrées</span> selon le groupe de clôture <span className="span-bold">"Scénario épuisé"</span>
    </div>
);